import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@fortawesome/pro-light-svg-icons/faCircleCheck';

import BluePreloader from '../../GeneralComponents/BluePreloader';
import { CfModal } from '../../Shared/CfModal';

import Styles from './styles.module.scss';

const WatchlistCreateModal = ({
  show,
  state,
  resetModal,
  createWatchlist,
  numberOfCreated,
  isWlNameTaken,
  value,
  setValue,
}) => {
  const history = useHistory();

  const getTitle = () => {
    switch (state) {
      case 'creating':
        return 'Creating Watchlist';
      case 'initial':
        return 'Name Your Watchlist';
      default:
        return '';
    }
  };

  const getContent = () => {
    switch (state) {
      case 'creating':
        return (
          <>
            <div className={Styles['creating-wl-message']}>
              This could take up to a few minutes
            </div>
            <BluePreloader className={Styles['creating-wl-loader']} active />
          </>
        );
      case 'initial':
        return (
          <>
            <input
              className={Styles['wl-name-input']}
              type="text"
              placeholder="Watchlist Name"
              value={value}
              onChange={(e) => setValue(e.target.value)}
            />
            {isWlNameTaken && (
              <div className={Styles['wl-name-taken']}>
                Watchlist name is already taken
              </div>
            )}
          </>
        );
      case 'created':
        return (
          <>
            <FontAwesomeIcon icon={faCircleCheck} className={Styles['created-icon']} />
            <h3 className={Styles['wl-created-title']}>
              {numberOfCreated ? `${numberOfCreated} ` : ''}
              Watchlist(s) Created
            </h3>
            <div className={Styles['wl-names']}>
              {numberOfCreated > 1 ? (
                Array.from({ length: numberOfCreated })
                  .map((_, i) => (`${value}${i + 1}`))
                  .join(', ')
              ) : value}
            </div>
          </>
        );
      default:
        return null;
    }
  };

  const goToWatchlist = async () => {
    history.push(numberOfCreated > 1 ? '/watchlists/manage' : '/watchlists');
  };

  return (
    <CfModal
      show={show}
      showCloseIcon={false}
      title={getTitle()}
      onCancel={resetModal}
      onConfirm={state === 'created' ? goToWatchlist : createWatchlist}
      disableConfirmButton={!value}
      cancelButtonText={state === 'created' ? 'Back to page' : 'Back'}
      hideCancelButton={state === 'creating'}
      confirmButtonText={state === 'created' ? `Go to Watchlist${numberOfCreated > 1 ? 's' : ''}` : 'Confirm'}
      hideConfirmButton={state === 'creating'}
    >
      {getContent()}
    </CfModal>
  );
};

WatchlistCreateModal.propTypes = {
  show: PropTypes.bool,
  state: PropTypes.oneOf([
    'initial',
    'creating',
    'created',
  ]),
  resetModal: PropTypes.func,
  createWatchlist: PropTypes.func,
  numberOfCreated: PropTypes.number,
  isWlNameTaken: PropTypes.bool,
  value: PropTypes.string,
  setValue: PropTypes.func,
};

WatchlistCreateModal.defaultProps = {
  show: false,
  state: 'initial',
  resetModal: () => {},
  createWatchlist: () => {},
  numberOfCreated: 1,
  isWlNameTaken: false,
  value: '',
  setValue: () => {},
};

export default WatchlistCreateModal;
